import { atom } from 'recoil';

export const assignmentFeedback = atom({
  key: 'assignment_feedback',
  default: {
    results: [],
    desc: true,
    order_by: '_created',
    total: null,
    size: 20,
    page: 1,
    screen: null,
    search_text: '',
    appeal_status: '',
  },
});
